<template>
  <div>
    <VSectionBar
      id="q-and-a"
      message="よくあるご質問"
    />
    <v-q-and-a-cards/>
  </div>
</template>

<script>
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VQAndACards from '@/components/organisms/lp/minecraft//VQAndACards.vue'

export default {
  name: 'VFaq',
  components: {
    VSectionBar,
    VQAndACards
  }
}
</script>